(function () {
    'use strict';

    angular.module("imApp").factory("productCategoryService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductCategory: function (parms) {
                return $ihttp.post({
                    method: 2710,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2712,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
